exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2vy8bJGTwEqZL1fhtL8s3m{max-height:436px}", ""]);
// Exports
exports.locals = {
	"categoryMenu": "_2vy8bJGTwEqZL1fhtL8s3m"
};